import Reveal from "@/components/Reveal";
import { MapPin, NavigationArrow, Clock } from "@phosphor-icons/react";

const ADDRESS = "Laguna de las Palomas 304, Nueva Oxtotitlán, 50100 Toluca de Lerdo, México";
const MAP_EMBED =
  "https://maps.google.com/maps?q=Laguna+de+las+Palomas+304,+Nueva+Oxtotitl%C3%A1n,+50100+Toluca+de+Lerdo,+M%C3%A9xico&t=&z=16&ie=UTF8&iwloc=&output=embed";
const DIRECTIONS =
  "https://www.google.com/maps/dir/?api=1&destination=Laguna+de+las+Palomas+304,+Nueva+Oxtotitl%C3%A1n,+50100+Toluca+de+Lerdo,+Mexico";

const Ubicacion = () => (
  <section id="ubicacion" className="relative border-t border-white/10 bg-ink py-28 lg:py-36" data-testid="ubicacion-section">
    <span className="outline-text pointer-events-none absolute -right-6 top-10 select-none font-serif text-[14vw] leading-none" aria-hidden="true">
      Toluca
    </span>
    <div className="relative mx-auto max-w-[1600px] px-6 lg:px-12">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <div>
          <Reveal>
            <p className="mb-8 flex items-center gap-4 text-[10px] font-light uppercase tracking-[0.5em] text-fire" data-testid="ubicacion-eyebrow">
              <span className="inline-block h-px w-16 bg-fire" /> Encuéntranos
            </p>
            <h2 className="font-serif text-5xl leading-[0.95] tracking-tight text-paper sm:text-7xl" data-testid="ubicacion-title">
              En el corazón de <em className="italic text-gold">Toluca</em>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-12 space-y-0 border-t border-white/10">
              <div className="flex items-start gap-5 border-b border-white/10 py-7" data-testid="ubicacion-direccion">
                <MapPin size={22} weight="light" className="mt-1 shrink-0 text-fire" />
                <div>
                  <p className="text-[10px] font-light uppercase tracking-[0.35em] text-smoke">Dirección</p>
                  <p className="mt-2 font-serif text-2xl leading-snug text-paper">{ADDRESS}</p>
                </div>
              </div>
              <div className="flex items-start gap-5 border-b border-white/10 py-7" data-testid="ubicacion-horario-resumen">
                <Clock size={22} weight="light" className="mt-1 shrink-0 text-fire" />
                <div>
                  <p className="text-[10px] font-light uppercase tracking-[0.35em] text-smoke">Reunión principal</p>
                  <p className="mt-2 font-serif text-2xl text-paper">Domingos · 10:00 AM – 12:00 PM</p>
                </div>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <a
              href={DIRECTIONS}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="ubicacion-directions-btn"
              className="group mt-10 inline-flex items-center gap-3 border border-paper/30 px-8 py-4 text-[11px] font-medium uppercase tracking-[0.3em] text-paper transition-colors duration-300 hover:border-paper hover:bg-paper hover:text-ink"
            >
              <NavigationArrow size={15} weight="light" className="transition-transform duration-300 group-hover:rotate-12" />
              Cómo llegar
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <div className="border border-white/10" data-testid="map-container">
            <iframe
              src={MAP_EMBED}
              title="Mapa Iglesia Viento de Gracia"
              className="map-dark aspect-[4/3] w-full"
              loading="lazy"
              data-testid="map-iframe"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Ubicacion;
